import { Input, Bubble } from 'tea-component'

import { useLocal } from '@/pages/dashboard/utils/customHook';
import { TYPES } from '../../_config/constant'
import useSelector from '../../hooks/useSelector'

const Selector = (props) => {
  const { defaultValue, onConfirm, onCancel, close, alignedBy } = props
  const { isEN, locale, getLocalText } = useLocal();
  const {
    type,
    rangeDate,
    errorMessage,
    handleConfirm,
    handleCancel,
    handleTypeChange,
    handleRangeDateChange
  } = useSelector({
    defaultValue,
    onConfirm,
    onCancel,
    close
  })

  return (
    <div className='range-day-month-selector-dropdown-competitor'>
      <div className='range-day-month-selector-tab-type'>
        {
          TYPES?.map(item => (
            <span
            className={`
              range-day-month-selector-tab-type-item
              ${item.value === type ? 'range-day-month-selector-active' : ''}
            `}
            onClick={() => handleTypeChange(item.value)}
            >
              {getLocalText(`competitor_launch_${item.name}`)}
            </span>
          ))
        }
      </div>
      <div className='range-day-month-selector-range-input'>
        {getLocalText(alignedBy?.textId || 'competitor_launch')}
        <Bubble
          visible={errorMessage[0]?.length > 0 ? true : false}
          overlayClassName='range-day-month-selector-bubble'
          placement='bottom'
          content={errorMessage[0]}
          error
        >
          <Input
            value={rangeDate[0]}
            onChange={(value) => handleRangeDateChange([value, rangeDate[1]])}
          />
        </Bubble>
        <i>-</i>
        <Bubble
          visible={errorMessage[1]?.length > 0 ? true : false}
          overlayClassName='range-day-month-selector-bubble'
          placement='bottom'
          content={errorMessage[1]}
          error
        >
          <Input
            value={rangeDate[1]}
            onChange={(value) => handleRangeDateChange([rangeDate[0], value])}
          />
        </Bubble>
        {getLocalText(`competitor_launch_${type}`)}
      </div>
      <div className='range-day-month-selector-footer'>
        <span
          className='range-day-month-selector-footer-confirm'
          onClick={handleConfirm}
        >
          {getLocalText('common_confirm')}
        </span>
        <span
          className='range-day-month-selector-footer-cancel'
          onClick={handleCancel}
        >
          {getLocalText('common_cancel')}
        </span>
      </div>
    </div>
  )
}

export default Selector